module.exports = __webpack_public_path__ + "images/_/programs/keepCool/images/characters/apprenticesFlexArms-4aeefe98ba101c125fbc6e150654e893.png";


//////////////////
// WEBPACK FOOTER
// ./programs/keepCool/images/characters/apprenticesFlexArms.png
// module id = 901
// module chunks = 2